import { Endpiont } from 'shared/utils/Endpoints';
import { HTTP_CLIENT } from '../../utils/Interceptor';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { toastMessage } from 'shared/components/toast/Toast';

// ------------------ list Return Order -------
const getAllReturnOrder = async (filter) => {
    const {
        data: { data }
    } = await HTTP_CLIENT.get(Endpiont.returnOrder.list + `${filter ? '?' + filter : ''}`);
    return data;
};

const GetAllReturnOrderQuery = (filter) => {
    return useQuery(['ReturnOrderList', filter], () => getAllReturnOrder(filter));
};

// ------------------ Add Return Order -------
const addReturnOrder = async (payload) => {
    return await HTTP_CLIENT.post(Endpiont.returnOrder.add, payload);
};

const AddReturnOrderMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(addReturnOrder, {
        onSuccess: (data) => {
            queryClient.invalidateQueries('ReturnOrderList');
            toastMessage('success', 'Return Order Created Successfully!');
        },
        onError: (error) => {
            const desc = error?.response?.data?.desc;
            const message = error?.response?.data?.message;
            toastMessage('error', desc || message || 'Server Error');
        }
    });
};

export { AddReturnOrderMutation, GetAllReturnOrderQuery };
